import {
  applyPlatformDownloadMeta,
  fetchPlatformAttachmentDownload,
  type PlatformDownloadResult,
} from '@/common/utils/platformDownload';
import type { FileItem } from '@/common/types/fileItem';
import type { PlatformDownloadMeta } from '@/common/utils/fileAttachmentsUniData';

export interface DownloadFileParams {
  type: string
  code: number
  version: number
  fileName: string
  elementId: number | string
  hash?: string
  sessionId: string
}

export type DownloadFileResult = PlatformDownloadResult

export const fileService = {
  async downloadFile(data: DownloadFileParams): Promise<DownloadFileResult | null> {
    const item: FileItem = {
      fields: {
        code: { type: 'Long', value: data.code },
        version: { type: 'Long', value: data.version },
        name: { type: 'String', value: data.fileName },
        ...(data.hash ? { hash: { type: 'String', value: data.hash } } : {}),
      },
    }

    try {
      const result = await fetchPlatformAttachmentDownload({
        elementId: data.elementId,
        sessionId: data.sessionId,
        type: data.type,
        item,
      })
      if (!result) return null

      applyPlatformDownloadMeta(item, data.elementId, result.meta)
      return result
    } catch (error) {
      console.error('downloadFile error:', error);
      return null;
    }
  }
}

export type { PlatformDownloadMeta }
